import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import '../../styles/errorHandler.css'

function ErrorHandlerAlert(props) {
    const { errorHandlerReducerState } = props;
    const [ show, setShow ] = useState(false);

    useEffect( () => { 
        setShow(false);        
        if(errorHandlerReducerState.hasError){
            setShow(true);
        }
    }, [errorHandlerReducerState]);

    return (
        <div>
            { 
                errorHandlerReducerState.hasError === true ? 
                console.log('ErrorHandlerAlert.js errorHandlerReducerState: ' + JSON.stringify()) 
                : ''
            }
            {show ? (
                <div className='statusUpdatesFailed'>
                    <h5>{JSON.stringify(errorHandlerReducerState.errorMessage).replace(/"/g, "")}</h5>
                </div>
            ) : <div>
                </div>
            }

        </div>
    );
}



const mapStateToProps = (state) => {   
    return {
        errorHandlerReducerState: state.errorHandlerReducer,
        //authreducerState: state.authreducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorHandlerAlert);